<template>
  <section>
    <div
      class="relative flex md:gap-10 gap-4 bg-h-primary-500 bg-opacity-70 bg-cover items-center rounded-md my-6 py-6 px-9 bg-center lg:bg-cover w-full md:h-[138px] h-20"
      :style="`background-image: url(${content.imageBanner}); `" id="banner-forum">
      <div :class="isTeacherOrAdmin ? 'bg-gradient-to-r from-black/80 to-transparent' : ''"
        class="absolute inset-0 flex items-center gap-4 py-6 rounded-md px-9 md:gap-11">

        <img :src="require('@/assets/images/icon-forum.svg')" alt="" class="md:h-[96px] h-[40px] " />

        <h2 class="text-white font-medium jost-span leading-10 text-[28px] md:text-5xl line-clamp-2"
          :class="isTeacherOrAdmin ? 'md:text-[28px]' : ''">
          {{ content.nameBanner }}
        </h2>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "banner-forum",
  props: {
    content: {
      type: Object,
      required: true,
    },
    isTeacherOrAdmin: {
      type: Boolean,
      required: true,
    },
  },
});
</script>
